const ONE_GB = 1000000000;
const TEN_GB = ONE_GB * 10;

const canAddFiles = (currentFiles = [], files = [], translations = {}) => {
    const pageTranslations = translations.js

    const total = getFilesSizeTotal(currentFiles);

    const names = currentFiles.map(function(file) { return file.file.name });

    const results = [];

    for (let i = 0; i < files.length; i++) {
        const result = {
            permitted: true,
            message: ''
        };
        const file = files[i];
        if (file) {
            if (file.size > 0) {
                if ((total + file.size) > TEN_GB) {
                    throw new Error(`${file.name} ${pageTranslations.not_be_added}`);
                } else if (names.indexOf(file.name) !== -1) {
                    result.permitted = false;
                    result.message = `${file.name} ${pageTranslations.has_been_added}`;
                }
            } else {
                result.permitted = false;
            }
        } else {
            result.permitted = false;
        }

        if (result.permitted) results.push(file);
    }

    return results;
};

function getFilesSizeTotal(files) {
    let total = 0;

    files.forEach(function(file) {
        total += file.file.size;
    })

    return total
}

export default canAddFiles;